import { AAResponseMapper, ResponseError, } from "@finarkein/aasdk-core";
export class ResponseMapperSaafe extends AAResponseMapper {
    constructor(response) {
        super(response);
    }
    async getResponse(operation) {
        // eslint-disable-next-line no-async-promise-executor
        return new Promise(async (resolve, reject) => {
            var _a, _b;
            try {
                const response = await this.response;
                const { status, message, ...rest } = response;
                const responseObj = {
                    data: rest,
                    aaOperation: response.aaOperation,
                    aaOpAttempt: response.attempt,
                    aaErrorCode: response.errorCode,
                    aaMessage: response === null || response === void 0 ? void 0 : response.message,
                    status: "FAILURE"
                };
                switch (operation) {
                    case "VALIDATE_USER":
                        this.handleValidateUser(response, responseObj);
                        break;
                    case "AA_LOGIN":
                        this.handleAALogin(response, responseObj);
                        break;
                    case "ACCOUNT_DISCOVERY":
                        this.handleAccountDiscovery(response, responseObj);
                        break;
                    case "LINKED_ACCOUNTS":
                    case "CONSENT_DETAILS":
                        this.handleLinkedAccountsOrConsentDetails(response, responseObj);
                        break;
                    case "ALT_MOBILE":
                        this.handleAltMobile(response, responseObj);
                        break;
                    case "CONFIRM_ALT_MOBILE":
                        this.handleConfirmAltMobile(response, responseObj);
                        break;
                    case "ACCOUNT_LINKING":
                        this.handleAccountLinking(response, responseObj);
                        break;
                    case "CONFIRM_ACCOUNT_LINKING":
                        this.handleConfirmAccountLinking(response, responseObj);
                        break;
                    case "CONSENT_ACTION":
                        this.handleConsentAction(response, responseObj);
                        break;
                    case "USER_INFO":
                        this.handleUserInfo(response, responseObj);
                        break;
                    case "LOGOUT":
                        this.handleLogout(response, responseObj);
                        break;
                    default:
                        reject(new ResponseError("UNKNOWN_OPERATION", responseObj, "Unknown operation type"));
                }
                console.log(responseObj);
                if (responseObj.status !== "SUCCESS") {
                    reject(new ResponseError(`${responseObj.status}`, responseObj, (_b = (_a = response.message) !== null && _a !== void 0 ? _a : responseObj.message) !== null && _b !== void 0 ? _b : ""));
                }
                resolve(responseObj);
            }
            catch (e) {
                reject(e);
            }
        });
    }
    handleValidateUser(response, responseObj) {
        if (response.statusCode === 200) {
            responseObj.status = "SUCCESS";
        }
        else if (response.statusCode === 400) {
            // bad request - we can't do anything
            responseObj.status = "BAD_REQUEST";
            responseObj.message = "Some error occurred, please try again after some time";
        }
        else {
            responseObj.status = "UNKNOWN_ERROR";
            responseObj.message = "Some error occurred, please try again after some time";
        }
    }
    handleAALogin(response, responseObj) {
        if (response.statusCode === 200) {
            responseObj.status = "SUCCESS";
        }
        else if (response.statusCode === 400) {
            if (response.errorCode === "Incorrect otp") {
                responseObj.status = "RETRY";
                responseObj.message = "Incorrect OTp";
            }
        }
        else {
            responseObj.status = "UNKNOWN_ERROR";
            responseObj.message = "Some error occurred, please try again after some time";
        }
    }
    handleAccountDiscovery(response, responseObj) {
        if (response.statusCode === 201 || response.statusCode === 200) {
            responseObj.status = "SUCCESS";
        }
        else if (response.statusCode === 400) {
            responseObj.status = "BAD_REQUEST";
            responseObj.message = "Invalid mobile identifier value";
        }
        else if (response.statusCode === 401 || response.statusCode === 403) {
            responseObj.status = "SESSION_ERROR";
            responseObj.message = "Session Timed Out. Please restart the journey";
        }
        else {
            responseObj.status = "UNKNOWN_ERROR";
            responseObj.message = "Some error occurred, please try again after some time";
        }
    }
    handleLinkedAccountsOrConsentDetails(response, responseObj) {
        if (response.statusCode === 200) {
            responseObj.status = "SUCCESS";
        }
        else {
            responseObj.status = "UNKNOWN_ERROR";
            responseObj.message = "Some error occurred, please try again after some time";
        }
    }
    handleConfirmAltMobile(response, responseObj) {
        if (response.statusCode === 200) {
            responseObj.status = "SUCCESS";
            responseObj.data = response.data;
        }
        else if (response.statusCode === 400) {
            if (response.errorCode === "Invalid Otp") {
                responseObj.status = "RETRY";
                responseObj.message = "Otp Verfication Failed";
            }
            else {
                responseObj.status = "FAILURE";
                responseObj.message = "Some error occurred, please try again after some time";
            }
        }
        else {
            responseObj.status = "UNKNOWN_ERROR";
            responseObj.message = "Some error occurred, please try again after some time";
        }
    }
    handleAltMobile(response, responseObj) {
        if (response.statusCode === 200) {
            responseObj.status = "SUCCESS";
        }
        else if (response.statusCode === 400) {
            if (response.errorCode === "Identifier is already registered") {
                responseObj.status = "ALREADY_REGISTERED";
                responseObj.message = "Identifier is already registered";
            }
            else {
                responseObj.status = "FAILURE"; //retry after 2-3 sec total - 10sec - failure
                responseObj.message = "Some error occurred, please try again after some time";
            }
        }
        else if (response.statusCode === 401 || response.statusCode === 403) {
            responseObj.status = "SESSION_ERROR";
            responseObj.message = "Session Timed Out. Please restart the journey";
        }
        else {
            responseObj.status = "FAILURE";
            responseObj.message = "Some error occurred, please try again after some time";
        }
    }
    handleAccountLinking(response, responseObj) {
        if (response.statusCode === 200 || response.statusCode === 201) {
            responseObj.status = "SUCCESS";
        }
        else if (response.statusCode === 400) {
            responseObj.status = "BAD_REQUEST";
            responseObj.message = "Failed to link account";
        }
        else if (response.statusCode === 500) {
            responseObj.status = "FAILURE";
            responseObj.message = "Some error occurred, please try again after some time";
        }
        else if (response.statusCode === 401 || response.statusCode === 403) {
            responseObj.status = "SESSION_ERROR";
            responseObj.message = "Session Timed Out. Please restart the journey";
        }
    }
    handleConfirmAccountLinking(response, responseObj) {
        if (response.statusCode === 200 || response.statusCode === 201) {
            responseObj.status = "SUCCESS";
        }
        else if (response.statusCode === 400) {
            if (response.errorCode === "Invalid OTP" || response.errorCode === "Incorrect otp") {
                responseObj.status = "RETRY";
                responseObj.message = "The asset linking process could not completed due to incorrect authentication credentials. Pls re-try again with correct details";
            }
            else {
                responseObj.status = "BAD_REQUEST";
                responseObj.message = "Failed to link account";
            }
        }
        else if (response.statusCode === 500) {
            responseObj.status = "FAILURE";
            responseObj.message = "Some error occurred, please try again after some time";
        }
        else if (response.statusCode === 401 || response.statusCode === 403) {
            responseObj.status = "SESSION_ERROR";
            responseObj.message = "Session Timed Out. Please restart the journey";
        }
    }
    handleConsentAction(response, responseObj) {
        if (response.statusCode === 200 || response.statusCode === 201) {
            responseObj.status = "SUCCESS";
        }
        else if (response.statusCode === 400) {
            responseObj.status = "BAD_REQUEST";
            responseObj.message = "Invalid Consent accounts";
        }
        else if (response.statusCode === 401 || response.statusCode === 403) {
            responseObj.status = "SESSION_ERROR";
            responseObj.message = "Session Timed Out. Please restart the journey";
        }
        else {
            responseObj.status = "FAILURE";
            responseObj.message = "Some error occurred, please try again after some time";
        }
    }
    handleUserInfo(response, responseObj) {
        if (response.statusCode === 200) {
            responseObj.status = "SUCCESS";
        }
        else if (response.statusCode === 500) {
            responseObj.status = "FAILURE";
            responseObj.message = "Some error occurred, please try again after some time";
        }
        else {
            responseObj.status = "BAD_REQUEST";
            responseObj.message = "Invalid Customer Id";
        }
    }
    handleLogout(response, responseObj) {
        if (response.statusCode === 200) {
            responseObj.status = "SUCCESS";
        }
    }
}
//# sourceMappingURL=ResponseMapperSaafe.js.map